<svelte:options runes={false} />

<script>
  import { INSTANCE_MODES } from '../../api/runtime-config';

  export let status;
  export let archivedAt;
  export let instanceMode;
  export let issuanceBlocked;
  export let onIssue;
  export let onVoid;
  export let onRestore;
  export let onArchive;
  export let onReturnToDraft;

  // Voiding is one-way and sits beside Archive, which is not. Removing a single
  // hour-bit already confirms; the irreversible action should confirm at least
  // as loudly.
  function confirmVoid() {
    if (
      window.confirm(
        'Void this invoice? It stops accepting payments permanently and cannot be undone. Archive instead if you only want it off the active list.',
      )
    ) {
      onVoid();
    }
  }
</script>

<div class="button-row">
  {#if status === 'draft'}
    <button class="primary" disabled={issuanceBlocked} type="button" on:click={onIssue}>
      {instanceMode === INSTANCE_MODES.SOLO ? 'Issue & create payer link' : 'Issue'}
    </button>
    <button class="destructive" type="button" on:click={confirmVoid}>Void</button>
  {:else if status === 'issued'}
    {#if archivedAt}
      <button type="button" on:click={onRestore}>Restore</button>
    {:else}
      <button type="button" on:click={onArchive}>Archive</button>
      <button type="button" on:click={onReturnToDraft}>Return to draft</button>
    {/if}
    <button class="destructive" type="button" on:click={confirmVoid}>Void</button>
  {/if}
</div>
